import React from 'react'
import classNames from 'classnames'
import { useSelector } from 'react-redux'

import { IMainItem, IItem } from 'config/types'
import { RootState } from 'redux/reducers/rootReducer'

// import { useTranslation } from 'react-i18next'
// import { useHistory } from 'react-router'
// import { PATH_BRANDING } from 'config/paths'
import MenuItem from '../menu-item/MenuItem'
import './MenuPannel.scss'

interface IMenuPannel {
    menuItems: IMainItem[] | IItem[]
    subcategories?: boolean
}

const MenuPannel = ({
    menuItems,
    subcategories,
}: IMenuPannel): React.ReactElement => {
    const stepIndex = useSelector((state: RootState) => state.app.stepIndex)

    const specialItems = menuItems.filter(item =>
        ['employee', 'services', 'booking'].includes(item.name),
    )
    const regularItems = menuItems.filter(
        item => !['employee', 'services', 'booking'].includes(item.name),
    )

    return (
        <div
            className={classNames('menu-pannel', {
                'menu-pannel--subcategories': subcategories,
            })}
        >
            <ul
                className={classNames({
                    'menu-pannel__list': true,
                    'second-step': stepIndex === 1,
                })}
            >
                <div
                    className='menu-pannel__special-items'
                    id={
                        stepIndex === 14 && subcategories
                            ? 'fifteenth-step'
                            : ''
                    }
                >
                    {specialItems.map(item => (
                        <MenuItem key={item.key} menuItem={item} />
                    ))}
                </div>
                {regularItems.map(item => (
                    <MenuItem key={item.key} menuItem={item} />
                ))}
            </ul>
        </div>
    )
}

export default MenuPannel
